var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-banner"},[_c('mt-swipe',{staticClass:"m-banner",attrs:{"auto":4000}},_vm._l((_vm.list),function(item,index){return _c('mt-swipe-item',{key:index},[_c('img',{attrs:{"src":item.image,"alt":"","title":""},on:{"click":function($event){return _vm.bannerClick(item)}}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a42bf6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mobile/components/MyBanner/index.vue
// module id = null
// module chunks = 